export default {
  "base": "list-decimal ps-6 my-5 marker:text-muted"
}